// import interfaces
import { Aeroval } from '../../types/global';
import { marked } from 'marked';
declare var aeroval: Aeroval;

import aerochatAnimation from './assets/images/aerochat-animation.svg';

import * as utils from '../../utils'
import { setCookie, getCookie } from '../cookies'

import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane, faRotateLeft } from '@fortawesome/free-solid-svg-icons';

// Add the imported icons to the library
library.add(faPaperPlane, faRotateLeft);

const paperPlane = icon({ prefix: 'fas', iconName: 'paper-plane' });
const rotateLeft = icon({ prefix: 'fas', iconName: 'rotate-left' });

import './style.css';
import MODELS from './config.json';

const DEFAULT_MODEL = getCookie('chatbot-model') ? getCookie('chatbot-model') : MODELS['models'][0] //'llama-3.3-70b-specdec'
utils.initAPI();

export function start(model = DEFAULT_MODEL) {
    if (!MODELS['models'].includes(model) && !MODELS['models'].includes(model)) return;
    aeroval.AIModel = model;
    aeroval.NAnsweredQuestion = 0
    aeroval.conversationHistory = []

    // add modal to main-content div
    const appElement = document.getElementById('nav-tabContent')?.parentElement;
    if (!appElement) return;

    // models List
    var modelsList = ''
    for (let model of MODELS['models']) {
        modelsList += `<li><a class="dropdown-item model-select small text-body-secondary" href="#">${model}</a></li>`
    }

    // destroy dropdown element if it exists
    const AIDropdownElement = document.getElementById('ai-dropdown');
    if (AIDropdownElement) AIDropdownElement.remove()

    // add dropdown
    const AIDropdown = document.createElement('div');
    AIDropdown.id = 'ai-dropdown'
    AIDropdown.style.position = 'fixed'
    AIDropdown.innerHTML = `<div class="dropdown">
                                <button class="btn btn-${aeroval.settings.theme} dropdown-toggle p-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                    ✨ AI Assistant
                                </button>
                                <ul class="dropdown-menu bg-opacity-75 px-2">
                                    <div id="ai-header" class="w-100 sticky-top py-2">
                                        <div id="aerochat">
                                            <object 
                                                type="image/svg+xml" 
                                                data=${aerochatAnimation}
                                                id="aeroChat" 
                                                style="height: 50px">
                                            </object>
                                            <div style="position: relative">
                                                <span class="lead">AeroChat</span><span class="position-absolute top-0 start-100 translate-middle badge rounded-pill text-body-secondary">beta</span>
                                            </div>
                                        </div>
                                        <div id="ai-models" class="dropdown end">
                                            <button class="btn btn-xs dropdown-toggle text-body-secondary small text-end" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Model: ${aeroval.AIModel}
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end p-2">
                                                ${modelsList}
                                            </ul>
                                        </div>

                                    </div>
                                    
                                    <div id="ai-main">
                                        <div id="ai-content" class="w-100 pt-2"></div>
                                        <div id="ai-buttons" class="col-auto w-100 btn-group my-2" role="group">
                                            <button id="ai-ask-button" type="button" class="btn btn-${aeroval.settings.theme}"><span class="mx-2">${paperPlane.html}</span>Ask</button>
                                            <button id="ai-reset-button" type="button" class="btn btn-${aeroval.settings.theme}"><span class="mx-2">${rotateLeft.html}</span>Reset</button>
                                        </div>
                                    </div>
                                    <div id="ai-disclaimer" class="bottom-0 end-0 text-body-secondary small text-end">ChatBots can make mistakes. Check important info.</div>
                                </ul>
                            </div>`

    appElement.appendChild(AIDropdown)
    addChatForm()

    // Wait for the SVG to load
    const bgColor = aeroval.settings.theme == 'dark' ? '#212529' : '#FFFFFF'; // Replace with your custom background colors for dark and light themes.
    const svgObject = document.querySelector('#aeroChat') as HTMLObjectElement;
    svgObject.onload = () => {
        const svgDoc = svgObject.contentDocument;
        if (svgDoc) {
            const svgElement = svgDoc.querySelector('svg');
            if (svgElement) {
                svgElement.style.backgroundColor = bgColor;
                if (aeroval.settings.theme === 'dark') {
                    const elementToInvert = svgElement.querySelector('g');
                    if (elementToInvert) {
                        (elementToInvert as any).style.filter = 'invert(1)';
                    };
                }
            }
        }
    };

    // event on model select
    const modelSelectElements = document.querySelectorAll('.model-select')
    if (modelSelectElements.length === 0) return

    modelSelectElements.forEach(element => {
        element.addEventListener('click', () => {
            const AIDropdownElement = document.getElementById('ai-dropdown');
            if (AIDropdownElement) AIDropdownElement.remove()
            const chatbotModel = (element as any).innerText
            setCookie('chatbot-model', chatbotModel, 1)
            start(chatbotModel);
        })
    });
}

function addChatForm() {
    const AIContentElement = document.getElementById('ai-content');
    if (!AIContentElement) return;

    const questionId = `ai-question-${aeroval.NAnsweredQuestion}`;
    const answerId = `ai-answer-${aeroval.NAnsweredQuestion}`;

    const AIForm = document.createElement('div');
    AIForm.id = `ai-form-${aeroval.NAnsweredQuestion}`;
    AIForm.className = 'w-100';
    AIForm.innerHTML = `
        <div id="${questionId}" class="w-100 ai-question">
            <label class="form-label me-2">👤</label>
            <textarea class="form-control" rows="3" placeholder="Ask anything on those data"></textarea>
        </div>
        <div id="${answerId}" class="w-100 my-2 ai-answer d-none">
            <label class="form-label me-2">🤖</label>
            <div class="answer-content border rounded p-3 bg-white text-dark"></div>
        </div>`;

    AIContentElement.appendChild(AIForm);

    // Elements
    const questionTextarea = document.getElementById(questionId)?.querySelector('textarea') as HTMLTextAreaElement;
    const answerElement = document.getElementById(answerId);
    const answerContent = answerElement?.querySelector('.answer-content') as HTMLElement | null;

    const askButton = document.getElementById('ai-ask-button');
    const resetButton = document.getElementById('ai-reset-button');

    if (!questionTextarea || !askButton || !resetButton) return;

    // Auto-resize question textarea while typing
    questionTextarea.addEventListener('input', () => {
        questionTextarea.style.height = "auto";
        questionTextarea.style.height = `${questionTextarea.scrollHeight}px`;
    });

    // Submit on Enter (without Shift)
    questionTextarea.addEventListener('keydown', async (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            questionTextarea.disabled = true;
            await AICallback();
        }
    });

    // Submit on button click
    askButton.addEventListener('click', async () => {
        await AICallback();
    });

    async function AICallback() {
        const userPrompt = questionTextarea.value.trim();
        if (!userPrompt) return;

        document.body.style.cursor = 'wait';

        // Show answer container early (optimistic UI)
        answerElement?.classList.remove('d-none');
        if (answerContent) {
            answerContent.innerHTML = '<em>Thinking...</em>';
        }

        try {
            const groqCompletion = await getGroqChatCompletion(userPrompt);

            if (!groqCompletion || !groqCompletion.choices?.[0]?.message?.content) {
                if (answerContent) {
                    answerContent.innerHTML = '<span style="color: red;">Error: Could not get a response from the AI. Please try again.</span>';
                }
                return;
            }

            const response = groqCompletion.choices[0].message.content;

            // Render Markdown as HTML
            if (answerContent) {
                answerContent.innerHTML = marked.parse(response, {
                    gfm: true,           // GitHub flavored markdown → good tables
                    breaks: true
                }) as string;
            }

            // Store in history
            aeroval.conversationHistory.push({ user: userPrompt, ai: response });

            // Keep last 10 turns
            if (aeroval.conversationHistory.length > 10) {
                aeroval.conversationHistory.shift();
            }
        } catch (err) {
            console.error("Chat error:", err);
            if (answerContent) {
                answerContent.innerHTML = `<span style="color: red;">Error: ${err instanceof Error ? err.message : 'Unknown error'}</span>`;
            }
        } finally {
            questionTextarea.disabled = false;
            questionTextarea.focus();
            document.body.style.cursor = 'default';

            // Add next input form
            aeroval.NAnsweredQuestion++;
            addChatForm();

            // Optional: scroll to bottom
            if (AIContentElement) AIContentElement.scrollTop = AIContentElement.scrollHeight;
        }
    }

    // Reset button (already outside — kept as is)
    resetButton.addEventListener('click', () => {
        const AIContentElement = document.getElementById('ai-content');
        if (AIContentElement) {
            AIContentElement.innerHTML = '';
            start();
        }
    });
}

async function getGroqChatCompletion(userPrompt: string): Promise<any> {
    // system prompt with data
    var dataCall = ''
    if (aeroval.tab === 'heatmap') {
        const keyTime = utils.getKeyTime(aeroval.time, aeroval.season);
        dataCall = `${window.API_ROOT}/heatmap/${aeroval.project}/${aeroval.experiment.name}/${aeroval.frequency}/${aeroval.region}/${keyTime}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`;
    }

    // Create a conversation history string
    const conversationHistoryString = aeroval.conversationHistory.map((turn: any) => `${turn.user}\n${turn.ai}`).join('\n');

    // Create the full prompt
    let historicalUserPrompt = `${conversationHistoryString}\n${userPrompt}`
        .trim()
        .replace(/\n+/g, " ")           // replace any sequence of newlines with space
        .replace(/\s+/g, " ");          // normalize spaces
    const url = `${window.API_ROOT}/groq?` + new URLSearchParams({
        model: aeroval.AIModel.replaceAll('/', '|'),
        prompt: historicalUserPrompt,
        data_url: dataCall,
    }).toString();

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    })

    if (response.ok) {
        const data = await response.json()
        return data
    } else if (response.status === 413) {
        const data = await response.json()
        console.log(data)

        const AIAnswerElement = document.getElementById(`ai-answer-${aeroval.NAnsweredQuestion}`)
        const AIanswerTextAreaElement = AIAnswerElement?.querySelector(`textarea`)
        if (!AIAnswerElement || !AIanswerTextAreaElement) return;
        AIAnswerElement?.classList.remove('d-none')
        AIanswerTextAreaElement.value = `${data.detail.error}`

        // adjust text area size
        AIanswerTextAreaElement.style.height = "auto"; // Reset height to recalculate
        AIanswerTextAreaElement.style.height = AIanswerTextAreaElement.scrollHeight + 50 + "px"; // Adjust height to fit content
        AIanswerTextAreaElement.style.color = "red";

        aeroval.NAnsweredQuestion++
        addChatForm()
    }
}
